import React from "react";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { useTranslation } from "@/lib/i18n";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Gavel, CreditCard, Scale, AlertCircle } from "lucide-react";
export default function TermsPage() {
  const { t } = useTranslation();
  return (
    <PublicLayout>
      <div className="space-y-10 max-w-4xl mx-auto">
        <div className="space-y-4">
          <h1 className="text-4xl font-bold tracking-tight">{t('terms_title')}</h1>
          <p className="text-lg text-muted-foreground">
            Legal framework governing the use of the Cloudface portal and agent orchestration services.
          </p>
        </div>
        <Accordion type="single" collapsible className="w-full space-y-4">
          <AccordionItem value="item-1" className="border rounded-xl px-6 bg-card">
            <AccordionTrigger className="hover:no-underline">
              <div className="flex items-center gap-3 text-left">
                <Gavel className="w-5 h-5 text-primary" />
                <div>
                  <h3 className="font-semibold">1. Acceptance of Agreement</h3>
                  <p className="text-xs text-muted-foreground">Last updated: March 2026</p>
                </div>
              </div>
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed pt-2 pb-6">
              By accessing the portal, you agree to comply with these terms. We operate on a Software-as-a-Service (SaaS) model. 
              Misuse of AI agents for illegal activities or violation of provider policies (OpenAI, Anthropic) will result in immediate termination.
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value="item-2" className="border rounded-xl px-6 bg-card">
            <AccordionTrigger className="hover:no-underline">
              <div className="flex items-center gap-3 text-left">
                <CreditCard className="w-5 h-5 text-primary" />
                <div>
                  <h3 className="font-semibold">2. Payments & Billing</h3>
                  <p className="text-xs text-muted-foreground">Powered by Stripe</p>
                </div>
              </div>
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed pt-2 pb-6">
              Fees are billed monthly based on your plan and token usage. All payments are final and non-refundable unless 
              required by law. Cloudface reserves the right to modify pricing with a 30-day notice.
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value="item-3" className="border rounded-xl px-6 bg-card">
            <AccordionTrigger className="hover:no-underline">
              <div className="flex items-center gap-3 text-left">
                <AlertCircle className="w-5 h-5 text-primary" />
                <div>
                  <h3 className="font-semibold">3. Limitation of Liability</h3>
                  <p className="text-xs text-muted-foreground">Risk & Governance</p>
                </div>
              </div>
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed pt-2 pb-6">
              Cloudface's total liability for any claim shall not exceed the fees paid by the user in the 12 months 
              preceding the claim. We are not responsible for the accuracy of AI-generated content.
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value="item-4" className="border rounded-xl px-6 bg-card">
            <AccordionTrigger className="hover:no-underline">
              <div className="flex items-center gap-3 text-left">
                <Scale className="w-5 h-5 text-primary" />
                <div>
                  <h3 className="font-semibold">4. Governing Law</h3>
                  <p className="text-xs text-muted-foreground">Jurisdiction</p>
                </div>
              </div>
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed pt-2 pb-6">
              This agreement is governed by the laws of Vietnam. Any disputes shall be settled in the competent courts of 
              Ho Chi Minh City (HCMC).
            </AccordionContent>
          </AccordionItem>
        </Accordion>
        <div className="text-center p-8 bg-muted/20 rounded-2xl border">
          <p className="text-sm text-muted-foreground">
            Questions about these terms? Reach out to our legal team at <span className="text-primary">legal@stv.vn</span>.
          </p>
        </div>
      </div>
    </PublicLayout>
  );
}